import { useEffect } from 'react';
import { useSendUXFEndedEvent } from 'UXF/hooks/useSendUXFEndedEvent';

export function useSendFeedback() {
    const sendUXFEndedEvent = useSendUXFEndedEvent();

    useEffect(() => {
        sendUXFEndedEvent();
    }, []);
}
